<template>
  <ModalDialog
    ref="dialog"
    title="Edit User Group"
    icon="fa-users"
    :submitting="submitting"
    submitTitle="Update"
    @closed="onClosed"
    @submitted="onSubmitted">

    <FormGroup v-bind:form="userGroupForm" :labelColumnSize="2">
      <FormRow label="Name"><FormInputText v-model="userGroup.name" field="name" /></FormRow>
      <FormRow label="Colour"><FormColourTag v-model="userGroup.colourTag" field="colourTag" /></FormRow>
      <FormRow label="Users"><FormMultiSelect :value="userGroupMembership" @input="userGroupMembership = $event" :options="userList" :loading="userListLoading" placeholder="Select Users" /></FormRow>
    </FormGroup>
  </ModalDialog>
</template>

<script>
import _ from 'lodash'
import form from '@/mixins/form'
import ModalDialog from '@/components/modalDialog.vue'
import modalDialog from '@/mixins/modalDialog'

export default {
  name: "UserGroupEditDialog",
  mixins: [
    modalDialog,
    form
  ],
  components: {
    ModalDialog
  },
  props: {
    userGroupId: Number
  },
  data() {
    return {
      userGroup: { },
      userGroupForm: {},
      submitting: false,
      userGroupMembership: [],
      userList: [],
      userListLoading: false
    }
  },
  mounted() {

  },
  computed: {
  },
  methods: {
    show(userGroup) {
      // Reset form
      this.userGroup = { }
      this.userGroupMembership = []
      this.userGroupForm = {}
      this.submitting = false
      this.userList = []

      if(userGroup != null) {
        this.userGroup = _.cloneDeep(userGroup)

        if(this.userGroup.users != null)
          this.userGroupMembership = this.userGroup.users.map(user => { return user.id })
      }
      
      // Get User list
      // FUTURE: Somehow send a promise to the select component. It can handle loading state based on promise
      this.userListLoading = true
      this.$apiService.userService.getUserList()
      .then(list => {
        this.userList = list.data.map(userInfo => {
          return {
            value: userInfo.id,
            name: userInfo.name
          }
        })
        this.userListLoading = false
      })

      return modalDialog.methods.show.call(this, arguments)
    },
    onClosed() {
      this.modalClosed(false)
    },
    onSubmitted() {
      this.submitting = true

      var userGroupData = _.cloneDeep(this.$data.userGroup)
      userGroupData.users = this.userGroupMembership
      
      // Only update certain fields
      var updateData = _.pick(userGroupData, ['name', 'colourTag', 'users'])

      this.$apiService.userService.updateUserGroup(this.userGroupId, updateData)
        .then(() => {
          this.submitting = false
          this.modalClosed(true)
          this.hide()
        })
        .catch(err => {
          this.submitting = false
          this.$data.userGroupForm = this.processFormResponse(err)
        })
    },
  }
}
</script>